import React from 'react';
import FormList from './FormList';
import SubformList from './SubformList';
import { useTranslation } from 'react-i18next';
import menu from './menu';

const DataFormSelection = () => {
  const { t } = useTranslation();
  return (
    <>
      {menu.map((item) => (
        <FormList
          key={`data-selection-${item.name}`}
          name={item.name}
          svgIcon={item.svgIcon}
          pathname={item.pathname}
        >
          {item.submenu?.map((subitem) => (
            <SubformList
              key={`data-selection-sub-${subitem.name}`}
              label={t(subitem.name)}
              pathname={subitem.pathname}
            />
          ))}
        </FormList>
      ))}
    </>
  );
};

export default DataFormSelection;
